/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPackage2Icon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-package-2"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.03 22.68L11.03 12.6L2.2 7.55L2.2 16.1Q2.2 16.82 2.55 17.44Q2.9 18.05 3.52 18.4ZM13.03 22.65L20.45 18.4Q21.07 18.05 21.43 17.44Q21.77 16.82 21.77 16.1L21.77 7.53L13.03 12.53ZM17.52 7.65L20.75 5.83L13.3 1.55Q12.7 1.2 12 1.2Q11.3 1.2 10.68 1.55L8.78 2.63ZM11.95 10.82L15.5 8.8L6.8 3.77L3.23 5.83Z" fill={color} />
    </svg>
  );
}
